import successfulActionComponent from './successfulAction.component';

let successfulActionModule = angular.module('vacations-absences.successfulAction', [])

.component('successfulAction', successfulActionComponent)

.name;

export default successfulActionModule;



// WEBPACK FOOTER //
// ./client/app/components/successfulAction/successfulAction.js